import axios from "axios";
import Endpoints from "../Endpoints";

export const getVersion = async () => {
    const { data } = await axios.get(Endpoints.Version.GET_VERSION);
    return data.data;
};

export const updateVersion = async (payload) => {
    const { data } = await axios.put(Endpoints.Version.UPDATE_VERSION, payload, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('USER_TOKEN')}`
        }
    });
    return data.data;
};
